Ext.ns('mx.data');

mx.data.EditorGridStore = function(config) {
    this.ajaxStubLatency = 1000;

    Ext.apply(this, config);

    this.reader = new mx.data.JsonReader(
        {
            totalProperty: 'total',
            successProperty: 'success',
            root: 'rows',
        },
        this.record
    );

    if (this.url) {
        this.proxy = new Ext.data.HttpProxy({url: mx.PATH + this.url});
    } else {
        this.proxy = new Ext.data.MemoryProxy({
            total: this.ajaxStubData.length,
            rows: this.ajaxStubData,
        });
        this.proxy.load = function() {
            Ext.data.MemoryProxy.prototype.load.defer(this.ajaxStubLatency, this.proxy, arguments);
        }.createDelegate(this);
    }

    this.groupOnSort = true;
    mx.data.EditorGridStore.superclass.constructor.call(this, config);
};

Ext.extend(mx.data.EditorGridStore, mx.data.Store, {
    createRecord: function(data) {
        Ext.Ajax.request({
            url: mx.PATH + this.url,
            method: 'POST',
            jsonData: data,
            scope: this,
            success: function(response) {
                var o = this.reader.read(response);
                if (o.success) {
                    if (o.records.length == 1 && o.records[0].data.id > 0) {
                        data.id = o.records[0].data.id;
                        this.add(new this.record(data));
                    }
                } else {
                    Ext.Msg.show({
                        msg: o.errors[0].message,
                        icon: Ext.Msg.ERROR,
                        buttons: Ext.Msg.OK,
                    });
                }
            },
            failure: function(response) {
                Ext.Msg.show({
                    title: 'Error ' + (response.status > 0 ? response.status : ''),
                    msg: response.statusText, //response.responseText - full response from server
                    icon: Ext.Msg.ERROR,
                    buttons: Ext.Msg.OK,
                });
            },
        });
    },
});
